import { render, staticRenderFns } from "./LeaveMassageEdit.vue?vue&type=template&id=2e09415d&scoped=true"
import script from "./LeaveMassageEdit.vue?vue&type=script&lang=js"
export * from "./LeaveMassageEdit.vue?vue&type=script&lang=js"
import style0 from "./LeaveMassageEdit.vue?vue&type=style&index=0&id=2e09415d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e09415d",
  null
  
)

export default component.exports